import { AvatarProps, Avatar as MuiAvatar } from "@mui/material";

type Props = AvatarProps;

export const Avatar = ({ children, ...props }: Props) => {
  return <MuiAvatar {...props}>{children}</MuiAvatar>;
};
